export const palette = {
    red: "#FF0000",
    orange: "#FFA500",
    yellow: "#FFFF00",
    green: "#007F73",
    blue: "#0000FF",
    indigo: "#4B0082",
    violet: "#EE82EE",
    white: "#FFFFFF",
    black: "#000000",
    primary: "#007F73",
    error: "#FF4D4F",
    gray: {
        100: "#F5F5F5",
        200: "#EEEEEE",
        300: "#E0E0E0",
        400: "#BDBDBD",
        500: "#9E9E9E",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121"
    }
};

export type PaletteKeyTypes = keyof typeof palette;
